import React from 'react'
import styled from 'styled-components'

export const Wrapper = styled.div`
  margin: 0 auto;
  width: 300px;
  max-height: 150px;
  overflow: auto;
  background-color: white;
  border-radius: 8px;
  & > div {
    border-bottom: 1px solid #ebebeb;
  }

  & > :last-child {
    border-bottom: none;
  }
`

export const Option = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 16px;
  cursor: pointer;
`

export const Label = styled.div`
`

export const Info = styled.div`
`

export default props => (
  <Wrapper>
    { props.options.map((o, i) => (
      <Option key={i} onClick={() => props.onSelect(o)}>
        <Label>{o.label}</Label>
        <Info>{o.info}</Info>
      </Option>
    ))}
  </Wrapper>
)
